export default __webpack_public_path__ + "static/media/video_3.1ab3583b.mp4";